// extracted by mini-css-extract-plugin
export default {"questionWrap":"TqSearchTqsCriteriaArea_questionWrap__mdfDs","linkSelectResponsesContainer":"TqSearchTqsCriteriaArea_linkSelectResponsesContainer__cVP+m"};